import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=0e87036e&scoped=true"
import script from "./referral.vue?vue&type=script&lang=js"
export * from "./referral.vue?vue&type=script&lang=js"
import style0 from "./referral.vue?vue&type=style&index=0&id=0e87036e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e87036e",
  null
  
)

export default component.exports